module.exports = __webpack_public_path__ + "static/media/locations.d71f31bf.svg";